import styled from '@emotion/styled';
import { TitleWrapper, ImageWrapper } from '@zola/zola-ui/src/components/PreAuthV3/Masthead.styles';
import { FeaturedImageWrapper } from '@zola/zola-ui/src/components/PreAuthV3/FeaturedImage.styles';
import FONT from '@zola/zola-ui/src/styles/emotion/fonts';
import MEDIA_QUERY from '@zola/zola-ui/src/styles/emotion/mediaQuery';
import SPACING from '@zola/zola-ui/src/styles/emotion/spacing';
import ContentfulResponsivePicture from '../ContentfulResponsivePicture';

export const FeaturedArticleContainer = styled.div`
  ${TitleWrapper} {
    ${FONT.textSizeCompact(FONT.SIZE.LARGER)};
  }

  ${ImageWrapper} {
    ${MEDIA_QUERY.DESKTOP} {
      padding: ${SPACING.LG} 0 ${SPACING.LG} ${SPACING.LG};
    }
  }
`;

export const AltMedia = styled(ContentfulResponsivePicture)`
  height: 100%;
  width: 100%;
  display: flex;
  > img {
    object-fit: cover;
    height: auto;
    width: 100%;
  }
`;

export const AltMediaWrapper = styled(FeaturedImageWrapper)``;
